import { ListItemIcon, Typography } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PropTypes from 'prop-types';
import React from 'react';
import IconButton from '../icon-button';
import MenuItem from '../menu-item';
import Popover from '../popover';

import styles from './styles.module.scss';

export const ProfileMenuItem = ({ children, Icon, ...props }) => (
    <MenuItem disableRipple {...props}>
        {Icon && (
            <ListItemIcon>
                <Icon fontSize="small" />
            </ListItemIcon>
        )}
        <Typography>{children}</Typography>
    </MenuItem>
);

ProfileMenuItem.propTypes = {
    children: PropTypes.node.isRequired,
    Icon: PropTypes.elementType
};

ProfileMenuItem.defaultProps = {
    Icon: null
};

export const ProfileMenu = ({ children }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                aria-label="Account menu"
                onClick={handleClick}
                className="Appbar-account"
                color="inherit"
            >
                <AccountCircleIcon />
            </IconButton>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handleClose}
                className={styles.popover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                {children}
            </Popover>
        </>
    );
};

ProfileMenu.propTypes = {
    children: PropTypes.node
};

ProfileMenu.defaultProps = {
    children: null
};
